import { useEffect } from "react";

/**
 * Lightweight per-page SEO without external deps.
 * Sets <title>, meta description, and key Open Graph tags.
 */
export function useSEO({ title, description, image }) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    const setMeta = (selector, attr, value) => {
      if (!value) return;
      let tag = document.querySelector(selector);
      if (!tag) {
        tag = document.createElement("meta");
        const [key, val] = selector.replace(/[[\]"']/g, "").split("=");
        tag.setAttribute(key, val);
        document.head.appendChild(tag);
      }
      tag.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:image"]', "content", image);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[name="twitter:image"]', "content", image);
  }, [title, description, image]);
}
